// Shown when the API declines to send a staff message because of how it reads.
// A dialog rather than a toast: it needs a moment of attention, and a long red
// banner in the corner felt like an error when nothing is broken — the message
// just needs rewording. The draft stays in the composer behind it.

import * as DialogPrimitive from "@radix-ui/react-dialog";
import { DialogOverlay, DialogPortal } from "../../components/ui/dialog";
import { Icon } from "../../components/msd/Icon";
import { Btn } from "../../components/msd/ui";

export default function ConductNotice({ notice, onClose }) {
  const reason = String(notice?.reason || "").trim();
  // Portalled into the shell rather than <body>, so the dialog keeps the
  // `.msd` design tokens (and with them the dark theme).
  const shell = typeof document !== "undefined" ? document.querySelector(".msd") : null;
  return (
    <DialogPrimitive.Root open={!!notice} onOpenChange={(open) => !open && onClose()}>
      <DialogPortal container={shell || undefined}>
        <DialogOverlay className="z-[80] bg-[rgba(15,21,48,.18)]" />
        <DialogPrimitive.Content
          data-testid="conduct-notice"
          className="fixed left-1/2 top-1/2 z-[80] w-[calc(100%-32px)] max-w-[380px] -translate-x-1/2 -translate-y-1/2 rounded-[22px] bg-msd-surface p-6 text-center text-msd-ink shadow-msd-pop outline-none"
        >
          <div className="mx-auto flex h-11 w-11 items-center justify-center rounded-xl bg-[#F79009] text-white">
            <Icon name="chat" size={22} />
          </div>
          <DialogPrimitive.Title className="m-0 mt-4 text-[20px] font-bold tracking-[-0.015em] text-msd-ink">
            Please use polite words
          </DialogPrimitive.Title>
          <DialogPrimitive.Description className="m-0 mt-[6px] text-[15px] leading-[1.4] text-msd-muted">
            {notice?.message}
          </DialogPrimitive.Description>
          {reason && (
            <p className="m-0 mt-3 rounded-xl bg-msd-ground px-3 py-2 text-[14px] text-msd-ink2">{reason}</p>
          )}
          <Btn variant="pri" onClick={onClose} className="mt-5 w-full">
            Edit message
          </Btn>
        </DialogPrimitive.Content>
      </DialogPortal>
    </DialogPrimitive.Root>
  );
}
